import script from "./DropdownToggleTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownToggleTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownToggleTemplate.vue?vue&type=style&index=0&id=1f994346&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f994346"]])

export default __exports__